import React, { useState, useEffect, useRef } from 'react'
import { ListGroup } from 'react-bootstrap'
import { Link, useLocation, useRouteMatch } from 'react-router-dom'
import { Collapse, Card } from 'react-bootstrap'
import { Row, Col, Dropdown } from 'react-bootstrap'
import navigation from '../../../menu-items'
import patientNavigation from '../../../patient-menu-items'
import { BASE_TITLE, BASENAME } from '../../../config/constant'
import namor from 'namor'
import { DesignProvider } from 'contexts/DesignContext'
import WidgetHeader from './WidgetHeader'

const images = require.context('../../../assets/images/user', true)

const PatientHeader = () => {
  let location = useLocation()
  let patientRouteMatch = useRouteMatch(
    '/patient-file/:section/:module/:submodule/'
  )
  const patientHeaderRef = useRef(null)
  const patientHeaderSentinelRef = useRef(null)
  const [accordionKey, setAccordionKey] = useState('')
  const [photo, setPhoto] = useState({ default: null })
  const hn = new URLSearchParams(location.search).get('hn') || ''
  const isPatientRoute = Boolean(patientRouteMatch)

  useEffect(() => {
    if (patientRouteMatch) {
      //setHn(patientRouteMatch.match.hn)
      setPhoto(getPhoto())
    }
  })

  useEffect(() => {
    if (!isPatientRoute) return undefined

    const patientHeader = patientHeaderRef.current
    const patientHeaderSentinel = patientHeaderSentinelRef.current
    const pageContainer = patientHeader?.closest('.pcoded-main-container')

    if (!patientHeader || !patientHeaderSentinel || !pageContainer) {
      return undefined
    }

    let animationFrameId = null
    let floatingSummary = null
    let summaryLeftInset = 0
    let summaryWidthInset = 0

    const clearFloatingSummary = () => {
      if (!floatingSummary) return

      floatingSummary.classList.remove(
        'patient-header-floating-summary',
        'patient-header-floating-summary--pinned'
      )
      floatingSummary = null
    }

    const getNavbarOffset = () => {
      const navbarOffset = window
        .getComputedStyle(pageContainer)
        .getPropertyValue('--patient-sticky-navbar-offset')

      return Number.parseFloat(navbarOffset) || 0
    }

    const updateFloatingHeader = () => {
      const summary = patientHeader.querySelector(
        '[role="button"][aria-expanded]'
      )

      if (!summary) {
        clearFloatingSummary()
        patientHeader.classList.remove('patient-header-sticky--pinned')
        patientHeader.style.removeProperty('--patient-header-summary-height')
        patientHeader.style.removeProperty('--patient-header-summary-left')
        patientHeader.style.removeProperty('--patient-header-summary-width')
        pageContainer.style.setProperty('--patient-header-height', '0px')
        return
      }

      if (floatingSummary !== summary) {
        clearFloatingSummary()
        floatingSummary = summary
        floatingSummary.classList.add('patient-header-floating-summary')
      }

      const isPinned = floatingSummary.classList.contains(
        'patient-header-floating-summary--pinned'
      )
      const patientHeaderRect = patientHeader.getBoundingClientRect()

      if (!isPinned) {
        const summaryRect = floatingSummary.getBoundingClientRect()

        summaryLeftInset = summaryRect.left - patientHeaderRect.left
        summaryWidthInset = patientHeaderRect.width - summaryRect.width
      }

      const summaryHeight = Math.ceil(
        floatingSummary.getBoundingClientRect().height
      )
      const summaryLeft = patientHeaderRect.left + summaryLeftInset
      const summaryWidth = Math.max(
        0,
        patientHeaderRect.width - summaryWidthInset
      )
      const isPinnedNext =
        patientHeaderSentinel.getBoundingClientRect().top <= getNavbarOffset()

      patientHeader.style.setProperty(
        '--patient-header-summary-height',
        `${summaryHeight}px`
      )
      patientHeader.style.setProperty(
        '--patient-header-summary-left',
        `${summaryLeft}px`
      )
      patientHeader.style.setProperty(
        '--patient-header-summary-width',
        `${summaryWidth}px`
      )
      pageContainer.style.setProperty(
        '--patient-header-height',
        `${summaryHeight}px`
      )
      patientHeader.classList.toggle(
        'patient-header-sticky--pinned',
        isPinnedNext
      )
      floatingSummary.classList.toggle(
        'patient-header-floating-summary--pinned',
        isPinnedNext
      )
    }

    const scheduleFloatingHeaderUpdate = () => {
      if (animationFrameId) return

      animationFrameId = window.requestAnimationFrame(() => {
        animationFrameId = null
        updateFloatingHeader()
      })
    }

    updateFloatingHeader()
    window.addEventListener('resize', scheduleFloatingHeaderUpdate)
    window.addEventListener('scroll', scheduleFloatingHeaderUpdate, {
      passive: true,
    })

    const resizeObserver = window.ResizeObserver
      ? new window.ResizeObserver(scheduleFloatingHeaderUpdate)
      : null

    resizeObserver?.observe(patientHeader)

    return () => {
      if (animationFrameId) window.cancelAnimationFrame(animationFrameId)
      resizeObserver?.disconnect()
      window.removeEventListener('resize', scheduleFloatingHeaderUpdate)
      window.removeEventListener('scroll', scheduleFloatingHeaderUpdate)
      clearFloatingSummary()
      patientHeader.classList.remove('patient-header-sticky--pinned')
      patientHeader.style.removeProperty('--patient-header-summary-height')
      patientHeader.style.removeProperty('--patient-header-summary-left')
      patientHeader.style.removeProperty('--patient-header-summary-width')
      pageContainer.style.removeProperty('--patient-header-height')
    }
  }, [isPatientRoute])

  const getPhoto = () => {
    const photo_new = 'avatar-' + Math.floor(Math.random() * 5 + 1) + '.jpg'
    let photo = images(`./${photo_new}`)
    return photo
  }

  const getAvatar = (name) => {
    return (
      <img
        src={photo.default}
        className="img-fluid img-radius wid-40"
        alt={name}
      />
    )
  }

  const randomDate = (start, end) => {
    let today = new Date(
      start.getTime() + Math.random() * (end.getTime() - start.getTime())
    )
    var dd = today.getDate()
    var mm = today.getMonth() + 1
    var yyyy = today.getFullYear()
    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }

    return yyyy + '-' + mm + '-' + dd
  }

  const onScrollToView = (id) => {
    document.getElementById(id).scrollIntoView()
  }

  if (!patientRouteMatch) {
    return false
  }

  const renderPatientBody = () => {
    return (
      <Card.Body className="py-0">
        <div className="user-about-block m-0">
          <Row>
            <Col md={4} className="text-center mt-n5">
              <div className="change-profile text-center">
                <Dropdown className="w-auto d-inline-block">
                  <Dropdown.Toggle as="a" variant="link" id="dropdown-basic">
                    <div className="profile-dp">
                      <div className="position-relative d-inline-block">
                        <img
                          className="img-radius img-fluid wid-100"
                          src={photo.default}
                          alt="User"
                        />
                      </div>
                      <div className="overlay">
                        <span>change</span>
                      </div>
                    </div>
                    <div className="certificated-badge">
                      <i className="fas fa-certificate text-c-blue bg-icon" />
                      <i className="fas fa-check front-icon text-white" />
                    </div>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item as={Link} to="#">
                      <i className="feather icon-upload-cloud mr-2" />
                      upload new
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="#">
                      <i className="feather icon-image mr-2" />
                      from photos
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="#">
                      <i className="feather icon-film mr-2" />
                      upload video
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="#">
                      <i className="feather icon-trash-2 mr-2" />
                      remove
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <h5 className="mb-1">Lary Doe</h5>
              <p className="mb-2 text-muted">UI/UX Designer</p>
            </Col>
            <Col md={8} className="mt-md-4">
              <Row>
                <Col>
                  <Link
                    to="#"
                    className="mb-1 text-muted d-flex align-items-end text-h-primary"
                  >
                    <i className="feather icon-globe mr-2 f-18" />
                    www.codedthemescom
                  </Link>
                  <div className="clearfix" />
                  <a
                    href="mailto:demo@domain.com"
                    className="mb-1 text-muted d-flex align-items-end text-h-primary"
                  >
                    <i className="feather icon-mail mr-2 f-18" />
                    demo@domain.com
                  </a>
                  <div className="clearfix" />
                  <Link
                    to="#"
                    className="mb-1 text-muted d-flex align-items-end text-h-primary"
                  >
                    <i className="feather icon-phone mr-2 f-18" />
                    +1 9999-999-999
                  </Link>
                </Col>
                <Col>
                  <div className="media">
                    <i className="feather icon-map-pin mr-2 mt-1 f-18" />
                    <div className="media-body text-left">
                      <p className="mb-0 text-muted">4289 Calvin Street</p>
                      <p className="mb-0 text-muted">
                        Baltimore, near MD Tower Maryland,
                      </p>
                      <p className="mb-0 text-muted">Maryland (21201)</p>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </Card.Body>
    )
  }

  const generate = (obj) => {
    return (
      Math.floor(Math.random() * 60 + 18) +
      '-' +
      Math.floor(Math.random() * 60 + 18)
    )
  }

  let nameEmail = generate({ words: 2, saltLength: 0, saltType: 'number' })
  const name = (
    nameEmail.charAt(0).toUpperCase() + nameEmail.slice(1)
  ).replaceAll('-', ' ')
  const sex = Math.floor(Math.random() * 2 + 1) > 1 ? 'Male' : 'Female'
  const date = randomDate(new Date(2012, 0, 1), new Date())
  const age = Math.floor(Math.random() * 60 + 18)
  const title = name

  const item = { id: 'patientInfo' }

  const breadcrumbContent = (
    <Card className="mt-2">
      <Card.Header>
        <Card.Title as="div">
          <Link
            to="#"
            onClick={() =>
              setAccordionKey(accordionKey !== item.id ? item.id : '')
            }
            aria-controls={item.id}
            aria-expanded={accordionKey === item.id}
          >
            <div className="page-header-title">
              <ul class="feed-blog pl-0  ">
                <li class="active-feed  ">
                  <div className="feed-user-img">{getAvatar(name)}</div>
                  <h5 className="m-b-10">
                    <small class="text-muted">
                      {name} {date}({age}), {sex}
                    </small>
                    {accordionKey === item.id ? (
                      <i className="fas fa-chevron-circle-down mr-3 font-medium-3" />
                    ) : (
                      <i className="fas fa-chevron-circle-left mr-3 font-medium-3" />
                    )}
                  </h5>
                </li>
              </ul>
            </div>
          </Link>
        </Card.Title>
      </Card.Header>
      <Collapse in={accordionKey === item.id}>
        <div id={item.id}>{renderPatientBody()}</div>
      </Collapse>
    </Card>
  )

  //document.title = title

  return (
    <React.Fragment>
      <div
        className="patient-header-sticky-sentinel"
        ref={patientHeaderSentinelRef}
      />
      <div
        className="patient-header-sticky patient-header-sticky--floating"
        ref={patientHeaderRef}
      >
        <DesignProvider key={hn}>
          <WidgetHeader widgetCode="header-patient" />
        </DesignProvider>
      </div>
    </React.Fragment>
  )
}

export default PatientHeader
